/**
 * The ArrayMesh processor: the section a path addresses in a cached `.tres` parse
 * (format=4) into geometry and material paths on the 'arraymesh' slot. Unlike a GLB Object3D, a
 * BufferGeometry is shared by identity: each consumer wraps it in its own <mesh>
 * and resolves the material paths through the StandardMaterial3D pipeline.
 */
import { createResourceProcessor } from '../createResourceProcessor';
import { ARRAY_MESH_TYPES, decodeArrayMesh } from '../meshes/arraymesh/decode';
import { godotSurfaceParts } from '../meshes/godotSurface';
import { arrayMeshAabb } from '../meshes/arraymesh/meshAabb';
export function createArrayMeshProcessor(eventBus, loadSection) {
    return createResourceProcessor({
        eventBus,
        resourceType: 'arraymesh',
        addressesSubResources: true,
        loadDirectly: async (path) => {
            const section = await loadSection(path, ARRAY_MESH_TYPES);
            const mesh = decodeArrayMesh(section, path);
            return {
                parts: godotSurfaceParts(mesh.surfaces).map(({ geometry, surfaces }) => ({
                    geometry,
                    materialPaths: surfaces.map((s) => s.materialPath ?? null),
                    surfaceIndices: surfaces.map((s) => s.surfaceIndex),
                })),
                aabb: arrayMeshAabb(section.properties),
            };
        },
        dispose: (resource) => resource.parts.forEach((part) => part.geometry.dispose()),
    });
}
//# sourceMappingURL=createArrayMeshProcessor.js.map